"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _classLib = require("class-lib");
var _reshowConstant = require("reshow-constant");
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _Label = _interopRequireDefault(require("../molecules/Label.js"));
var _index = _interopRequireDefault(require("../../lib/styles/index.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "labelProps", "barLabel", "barLabelProps", "barProps", "children", "className", "percent", "style", "styles"],
  _excluded2 = ["style", "styles"]; // @ts-check
/**
 * @param {{className?: string, [key: string]: any}} props
 */
var Progress = function Progress(props) {
  var label = props.label,
    labelProps = props.labelProps,
    barLabel = props.barLabel,
    barLabelProps = props.barLabelProps,
    barProps = props.barProps,
    children = props.children,
    className = props.className,
    percent = props.percent,
    style = props.style,
    styles = props.styles,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded);
  var thisLabel = label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Label["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    ui: false
  }, labelProps), {}, {
    children: label
  })) : children;
  var _ref = barProps || {},
    barStyle = _ref.style,
    barStyles = _ref.styles,
    restBarProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded2);
  var classes = (0, _classLib.mixClass)(className, "progress");
  restBarProps.children = barLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    className: "progress",
    ui: false
  }, barLabelProps), {}, {
    children: barLabel
  })) : restBarProps.children;
  var thisPercent = (percent !== null && percent !== void 0 ? percent : props["data-percent"]) * 1;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), {}, {
    className: classes,
    "data-percent": thisPercent,
    styles: [(0, _index["default"])(style, _reshowConstant.T_UNDEFINED, false), styles],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      className: "bar",
      ui: false
    }, restBarProps), {}, {
      cssList: [{
        cssModule: ["progress"],
        cssGroup: "semantic"
      }],
      styles: [(0, _index["default"])((0, _objectSpread2["default"])({
        width: thisPercent + "%"
      }, barStyle), _reshowConstant.T_UNDEFINED, false), barStyles]
    })), thisLabel]
  }));
};
var _default = exports["default"] = Progress;
module.exports = exports.default;